import { z } from 'zod';
import { vendorContactInfoSchema } from './quote-import';

export const parsedPaymentSchema = z.object({
  description: z.string(),
  amount: z.number().int().nullable().default(null),
  dueDate: z.string().nullable().default(null),
  dueDateDescription: z.string().nullable().default(null),
});

export const contractImportResultSchema = z.object({
  vendorName: z.string(),
  vendorContactInfo: vendorContactInfoSchema.default({
    contactName: null,
    email: null,
    phone: null,
    website: null,
  }),
  totalAmount: z.number().int().nullable().default(null),
  rawPaymentTerms: z.string(),
  payments: z.array(parsedPaymentSchema),
  clientSignedDate: z.string().nullable().default(null),
  vendorSignedDate: z.string().nullable().default(null),
  confidence: z.enum(['high', 'medium', 'low']),
  warnings: z.array(z.string()).default([]),
  suggestedCategory: z.string().default('Uncategorized'),
});

export type ContractImportResultOutput = z.infer<typeof contractImportResultSchema>;
